import * as React from 'react'
import Dropzone from 'react-dropzone'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import clouds from 'assets/images/import-clouds.svg'

import { observer } from 'mobx-react'

import { Authorized } from 'modules/core/components/Authorized'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import FileList from 'modules/documents/components/FileList'

import type { ContractImporterContextProps } from './contractsImporterContext'

type DropzoneProps = React.ComponentProps<typeof Dropzone>

interface DropZoneProps {
  onDropFile: DropzoneProps['onDrop']
}

const DropZone = ({ onDropFile }: DropZoneProps) => {
  const {
    company: { subscription },
  } = useCurrentSession()

  return (
    <Authorized subscription={subscription}>
      <Dropzone onDrop={onDropFile} multiple={false}>
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()}>
            <Box
              border={{
                all: {
                  width: 's2',
                  style: 'dashed',
                  color: 'grey400',
                },
              }}
              style={{
                borderRadius: '5px',
                padding: '30px 30px 25px 30px',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
              }}
            >
              <input {...getInputProps()} />
              <Box style={{ marginBottom: '5px' }}>
                <img src={clouds} />
              </Box>
              <Box style={{ color: 'grey500', textAlign: 'center' }}>
                {i18n.tView('import.drop_explanation', {
                  browse: (
                    <Box style={{ color: '#695EE8', fontWeight: '500', display: 'inline-flex' }}>
                      {i18n.t('import.browse')}{' '}
                    </Box>
                  ),
                })}
              </Box>
            </Box>
          </div>
        )}
      </Dropzone>
    </Authorized>
  )
}

interface Props {
  importer: ContractImporterContextProps
  openModalOnDrop?: boolean
}

const ContractsFileImporter = ({ importer, openModalOnDrop = false }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const onDropFile = (filesOnDrop: File[]) => {
    if (openModalOnDrop) {
      navigate(navigation.employees.list.importContracts.fullPath())
    }

    importer.setFiles(filesOnDrop)
  }

  const onDeleteFile = () => {
    importer.setFiles([])
  }

  if (openModalOnDrop) return <DropZone onDropFile={onDropFile} />

  return (
    <>
      <DropZone onDropFile={onDropFile} />
      {importer.hasFile && (
        <Box paddingTop="s24">
          <FileList files={importer.files} onDeleteFile={onDeleteFile} spaced={false} />
        </Box>
      )}
    </>
  )
}

export default observer(ContractsFileImporter)
